import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ContentHeader from '@common/component/organisms/ContentHeader';
import { Icon } from '@material-ui/core';
import SearchResultTable from '@common/container/organisms/SearchResultTableContainer';
import SearchConditionInput from '@common/container/molecules/SearchConditionInputContainer';
import {
  DEFAULT_PAGE_VIEW,
  SCREEN,
  ScrollInfo,
  sortButtonStatus,
  SORT_TYPE,
  SESSION_STORAGE_NEGOTATION_KEYS,
  setStorageValueByKey,
  getStorageValueByKey,
  removeKeysStorage,
  EVENT_LISTENER_KEYS,
  NEGOTIATION_SORT_SPOT_EVENT_MAPPING,
  NEGOTIATION_ACTION_SPOT_EVENT_MAPPING,
  FILTER_DRAWER_SPOT_EVENT_COMMON_MAPPING,
} from '@common/Common';
import { LoadingStatus } from '@common/redux/reducers/LoadingStatusReducer';
import { UserState } from '@common/redux/reducers/UserReducer';
import Layout from '../Layout';
import FilterSettingDrawer from '@common/component/organisms/FilterSettingDrawer';
import { StoreSelectorState } from '@common/redux/reducers/StoreSelectorReducer';
import { SearchConditionState } from '@common/redux/reducers/SearchConditionReducer';
import StoreSelectModal from '../../../container/organisms/StoreSelectModalContainer';
import { MasterInfoState } from '@common/redux/reducers/MasterInfoReducer';

interface SearchResultHandler {
  loadingStatus: LoadingStatus;
  loginUser: UserState;
  storeSelector: StoreSelectorState;
  searchCondition: SearchConditionState;
  masterInfo: MasterInfoState;
  search: (
    loginUser: UserState,
    storeSelector: StoreSelectorState,
    filterConditions: SearchConditionState,
    paging: ScrollInfo,
    sort: string
  ) => void;
}
interface SearchResultProps extends RouteComponentProps, SearchResultHandler {}

class SearchResult extends Component<SearchResultProps, any> {
  private initialSort: string;
  private initialPaging: ScrollInfo;
  private initialCurrentPage: number;
  private initialApiUpdateIndex: number;
  private initialSortButtonStatus: sortButtonStatus;
  private initialSearchBranchCount: number;

  constructor(props: SearchResultProps) {
    super(props);
    window.addEventListener(EVENT_LISTENER_KEYS.BEFORE_UNLOAD, this.handleBeforeUnload);
    if (!this.checkValueStorageExist()) {
      this.initSessionStorage();
    }
    this.initialSort = getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE);
    this.initialPaging = JSON.parse(getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE));
    this.initialCurrentPage = +getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.CURRENT_PAGE);
    this.initialApiUpdateIndex = +getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.API_UPDATE_INDEX);
    this.initialSearchBranchCount = 0;
    this.initialSortButtonStatus = {
      lastUpdateDate: SORT_TYPE.LAST_UPDATE_DATE_DESC,
      createDate: SORT_TYPE.CREATE_DATE_DESC,
      contractAccuracyType: SORT_TYPE.CONTRACT_ACCURACY_TYPE_ASC,
      actionDate: SORT_TYPE.ACTION_DATE_DESC,
    };
    this.state = {
      isOpenDrawer: false,
      paging: this.initialPaging,
      sort: this.initialSort,
      sortButtonStatus: this.initialSortButtonStatus,
      currentPage: this.initialCurrentPage,
      apiUpdateIndex: this.initialApiUpdateIndex,
      searchBranchCount: this.initialSearchBranchCount,
    };
    this.onSearch = this.onSearch.bind(this);
    this.onSearchWithChange = this.onSearchWithChange.bind(this);
  }

  handleBeforeUnload = () => {
    removeKeysStorage();
  };

  initSessionStorage = () => {
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE, SORT_TYPE.LAST_UPDATE_DATE_DESC);
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.CURRENT_PAGE, DEFAULT_PAGE_VIEW.CURRENT_PAGE);
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE, {
      size: 200,
      from: 0,
    });
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.API_UPDATE_INDEX, DEFAULT_PAGE_VIEW.API_UPDATE_INDEX);
  };

  checkValueStorageExist = () => {
    // only check 1 value
    const valueSortStorage = getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE);
    return !!valueSortStorage;
  };

  setCurrentPage(currentPage: number) {
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.CURRENT_PAGE, currentPage);
    this.setState({ currentPage });
  }
  setApiUpdateIndex(apiUpdateIndex: number) {
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.API_UPDATE_INDEX, apiUpdateIndex);
    this.setState({ apiUpdateIndex });
  }

  setSearchBranchCount(searchBranchCount: number) {
    this.setState({ searchBranchCount });
  }

  setSort(sort: string) {
    // Step1. State設定：ソート
    this.setState({ sort });

    // Step2. State設定：ソートボタン設定
    switch (sort) {
      case SORT_TYPE.LAST_UPDATE_DATE_ASC:
      case SORT_TYPE.LAST_UPDATE_DATE_DESC:
        this.setState({
          sortButtonStatus: {
            lastUpdateDate: sort,
            createDate: this.state.sortButtonStatus.createDate,
            contractAccuracyType: this.state.sortButtonStatus.contractAccuracyType,
            actionDate: this.state.sortButtonStatus.actionDate,
          },
        });
        break;
      case SORT_TYPE.CREATE_DATE_ASC:
      case SORT_TYPE.CREATE_DATE_DESC:
        this.setState({
          sortButtonStatus: {
            lastUpdateDate: this.state.sortButtonStatus.lastUpdateDate,
            createDate: sort,
            contractAccuracyType: this.state.sortButtonStatus.contractAccuracyType,
            actionDate: this.state.sortButtonStatus.actionDate,
          },
        });
        break;
      case SORT_TYPE.CONTRACT_ACCURACY_TYPE_ASC:
      case SORT_TYPE.CONTRACT_ACCURACY_TYPE_DESC:
        this.setState({
          sortButtonStatus: {
            lastUpdateDate: this.state.sortButtonStatus.lastUpdateDate,
            createDate: this.state.sortButtonStatus.createDate,
            contractAccuracyType: sort,
            actionDate: this.state.sortButtonStatus.actionDate,
          },
        });
        break;
      case SORT_TYPE.ACTION_DATE_ASC:
      case SORT_TYPE.ACTION_DATE_DESC:
        this.setState({
          sortButtonStatus: {
            lastUpdateDate: this.state.sortButtonStatus.lastUpdateDate,
            createDate: this.state.sortButtonStatus.createDate,
            contractAccuracyType: this.state.sortButtonStatus.contractAccuracyType,
            actionDate: sort,
          },
        });
        break;
    }
  }

  onSearch(loginUser: UserState, storeSelector: StoreSelectorState, filterConditions: SearchConditionState) {
    const sort = getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE) || '';
    const paging = JSON.parse(getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE));
    this.props.search(loginUser, storeSelector, filterConditions, paging, sort);
  }

  onSearchWithChange(paging: ScrollInfo, sort: string) {
    setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE, paging);
    this.setState({ paging, sort });
    this.props.search(this.props.loginUser, this.props.storeSelector, this.props.searchCondition, paging, sort);
  }

  componentDidMount(): void {
    this.setSort(getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE));
  }

  componentWillUnmount(): void {
    window.removeEventListener(EVENT_LISTENER_KEYS.BEFORE_UNLOAD, this.handleBeforeUnload);
  }

  render() {
    const { isOpenDrawer, paging, sort, sortButtonStatus } = this.state;

    return (
      <Layout isLoggedIn={this.props.loginUser.isLoggedIn}>
        <div className='layout-tab'>
          <div className='layout-tab__header u-bg-white'>
            <div className='container'>
              <ContentHeader
                screenId={SCREEN.NEGOTIATION_SEARCH_RESULT.ID}
                screenName={SCREEN.NEGOTIATION_SEARCH_RESULT.NAME}
                titleIcon={
                  <div className='dashboard-summary-icon-wrap dashboard-summary-icon-wrap--small dashboard-summary-icon-wrap--search u-float-left u-mr8'>
                    <Icon className='dashboard-summary-icon'>list_bulleted</Icon>
                  </div>
                }
                statusType=''
                loadingStatus={this.props.loadingStatus}
                data-testid='contentHeader'>
                <SearchConditionInput
                  toggleDrower={() => {
                    this.setState({ isOpenDrawer: !isOpenDrawer });
                  }}
                  data-testid='searchConditionInput'
                  searchBranchCount={this.state.searchBranchCount}
                />
              </ContentHeader>
            </div>
          </div>
          <hr className='uc-divider' />
          <div className='layout-tab__content'>
            <div className='container u-flex u-flex-column u-h-full'>
              {/* 検索結果エリア */}
              <SearchResultTable
                search={(paging, sort) => this.onSearchWithChange(paging, sort)}
                paging={paging}
                sort={sort}
                sortButtonStatus={sortButtonStatus}
                apiUpdateIndex={this.state.apiUpdateIndex}
                currentPage={this.state.currentPage}
                setApiUpdateIndex={(apiUpdateIndex) => this.setApiUpdateIndex(apiUpdateIndex)}
                setCurrentPage={(currentPage) => this.setCurrentPage(currentPage)}
                setSort={(sort) => this.setSort(sort)}
                masterInfo={this.props.masterInfo}
                data-testid='searchResultTable'
                sortSpotEvent={NEGOTIATION_SORT_SPOT_EVENT_MAPPING['AGENCY']}
                actionSpotEvent={NEGOTIATION_ACTION_SPOT_EVENT_MAPPING['AGENCY']}
              />

              {/* フィルターエリア ドロワー */}
              <FilterSettingDrawer
                setSearchBranchCount={(searchBranchCount) => this.setSearchBranchCount(searchBranchCount)}
                isOpen={isOpenDrawer}
                gaSpotEvent={FILTER_DRAWER_SPOT_EVENT_COMMON_MAPPING['AGENCY']}
                onClose={() => this.setState({ isOpenDrawer: false })}
                search={(loginUser, storeSelector, searchCondition) => this.onSearch(loginUser, storeSelector, searchCondition)}
                setCurrentPage={(currentPage: number) => {
                  setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.CURRENT_PAGE, currentPage);
                  this.setState({ currentPage });
                }}
                setPaging={(paging: object) => {
                  this.setState({ paging });
                }}
                setApiUpdateIndex={(newApiUpdateIndex: number) => this.setApiUpdateIndex(newApiUpdateIndex)}
                data-testid='filterSettingDrawer'
              />
            </div>
          </div>
        </div>
        <StoreSelectModal />
      </Layout>
    );
  }
}

export default SearchResult;
